import { VennDiagramDisplayConfig, VennDiagramParams } from './venn-diagram.model';

export const VENN_DIAGRAM_DEFAULT: VennDiagramParams = {
  sets: ['A', 'B'],
  highlighted: [{ A: true, B: true }],
  labelU: 'U',
};

export const VENN_DIAGRAM_UNION: VennDiagramParams = {
  sets: ['A', 'B'],
  highlighted: [
    { A: true, B: false },
    { A: false, B: true },
    { A: true, B: true },
  ],
  labelU: 'U',
};

export const VENN_DIAGRAM_COMPLEMENT_A: VennDiagramParams = {
  sets: ['A', 'B'],
  highlighted: [
    { A: false, B: true },
    { A: false, B: false },
  ],
  labelU: 'U',
};

export const VENN_DIAGRAM_THREE_SETS: VennDiagramParams = {
  sets: ['A', 'B', 'C'],
  highlighted: [{ A: true, B: true, C: true }],
  labelU: 'U',
};

export const VENN_DIAGRAM_MUTUALLY_EXCLUSIVE_DISPLAY: VennDiagramDisplayConfig = {
  hoverEnabled: true,
  mutuallyExclusive: true,
};

export const VENN_DIAGRAM_PROPORTIONAL: VennDiagramParams = {
  sets: ['A', 'B'],
  labelU: 'U',
  probabilities: {
    initialPA: 0.5,
    initialPB: 0.4,
    initialPAB: 0.2,
  },
};

export const VENN_DIAGRAM_INTERACTIVE_DISPLAY: VennDiagramDisplayConfig = {
  hoverEnabled: true,
  interactive: true,
};

export const VENN_DIAGRAM_PRESETS: Record<string, Record<string, unknown>> = {
  default: { params: VENN_DIAGRAM_DEFAULT },
  union: { params: VENN_DIAGRAM_UNION },
  'complement-a': { params: VENN_DIAGRAM_COMPLEMENT_A },
  'three-sets': { params: VENN_DIAGRAM_THREE_SETS },
  'mutually-exclusive': {
    params: { sets: ['A', 'B'], highlighted: [], labelU: 'U' },
    display: VENN_DIAGRAM_MUTUALLY_EXCLUSIVE_DISPLAY,
  },
  proportional: {
    params: VENN_DIAGRAM_PROPORTIONAL,
    display: VENN_DIAGRAM_INTERACTIVE_DISPLAY,
  },
};
